@if (formViewerService.initialized && formViewerService.formGroup) {
  <form autocomplete="off" name='form'
    [formGroup]="formViewerService.formGroup">
    <!-- fx-items-start + fascia da 40px sul pulsante: i div dei campi sono piu' alti
    del box (label sopra e subscript sotto), quindi centrarli non lo allineerebbe -->
    <div class="fx-row fx-items-start" style="gap: 12px">
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='formFields.get("start_station")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["start_station"]'
          [dataContainerService]='datasetACS'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='formFields.get("end_station")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["end_station"]'
          [dataContainerService]='datasetACS'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='formFields.get("carnet_type")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["carnet_type"]'
          [dataContainerService]='datasetACS'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='formFields.get("date")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["date"]'
          [dataContainerService]='datasetACS'
          [readOnly]=true
        ></form-input-viewer>
      </div>
      <div class="fx-flex" style="height:40px; display:flex; align-items:center">
        <button mat-raised-button (click)="search()"  [disabled]="!trnService.continue.value">Ricerca</button>
      </div>
    </div>
  </form>
}